import React from 'react'

const WebLayout = ({ children }) => (
  <>
      {children}
  </>  
)

export default WebLayout